import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Space, Input } from 'antd'
import * as Icons from '@ant-design/icons'
import { useQueryParam, StringParam } from 'use-query-params'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { ReferenceProductItemsList } from './ReferenceProductItemsList'

export function ReferenceProductItems() {
  const [searchTerm, setSearchTerm] = useQueryParam('search', StringParam)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: (
                  <BreadcrumbArrayItem>
                    <Link to={ROUTES.REFERENCE_DATA.INDEX}>Reference Data</Link>
                  </BreadcrumbArrayItem>
                )
              },
              {
                title: 'Reference Product Items'
              }
            ]}
          />

          <Space>
            <Input.Search
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value, 'replace')}
              style={{ maxWidth: '20rem' }}
            />

            <Link to={ROUTES.REFERENCEITEMS.REGISTER}>
              <Button type="primary" icon={<Icons.FolderAddOutlined />}>
                New
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      <ReferenceProductItemsList searchTerm={searchTerm} />
    </Layout>
  )
}
